import emailjs from '@emailjs/browser';
import { EMAILJS_CONFIG } from '../config/email';

interface FeedbackData {
  rating: number;
  comments: string;
  email: string;
  bookId: string;
  pathName: string;
}

// Initialize EmailJS
emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);

export async function sendFeedbackEmail(feedbackData: FeedbackData): Promise<void> {
  try {
    const templateParams = {
      to_email: 'support@voy-gr.com',
      from_name: feedbackData.email || 'Anonymous User',
      from_email: feedbackData.email || 'no-reply@voy-gr.com',
      rating: feedbackData.rating,
      comments: feedbackData.comments || 'No comments provided',
      book_id: feedbackData.bookId,
      path_name: feedbackData.pathName,
      user_email: feedbackData.email || 'Not provided',
      rating_text: getRatingText(feedbackData.rating),
      timestamp: new Date().toLocaleString()
    };

    await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams
    );

    console.log('Feedback email sent successfully');
  } catch (error) {
    console.error('Failed to send feedback email:', error);
    throw new Error('Failed to send feedback. Please try again.');
  }
}

function getRatingText(rating: number): string {
  const ratingTexts = {
    1: "Could be better",
    2: "It was okay", 
    3: "Pretty good",
    4: "Really enjoyed it",
    5: "Absolutely loved it!"
  };
  return ratingTexts[rating as keyof typeof ratingTexts] || "No rating";
}